'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'cube';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1b2';
var svgPathData = ['M16.5 154.5l0 203c0 22.9 12.2 44 32 55.4L224.3 514.5c9.9 5.7 21 8.6 32 8.6l0-230.1c0-22.9 12.2-44 32-55.4 66.4-38.4 132.9-76.7 199.3-115-5.5-9.6-13.5-17.7-23.4-23.4L288.3-2.5c-19.8-11.4-44.2-11.4-64 0L48.5 99c-19.8 11.4-32 32.6-32 55.4z', 'M487.6 122.5c5.5 9.6 8.6 20.6 8.6 32l0 203c0 22.9-12.2 44-32 55.4L288.3 514.5c-9.9 5.7-21 8.6-32 8.6l0-230.1c0-22.9 12.2-44 32-55.4l199.3-115z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCube = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;